import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'step-indicator',
  templateUrl: './step-indicator.component.html',
  styleUrls: ['./step-indicator.component.scss']
})
export class StepIndicator implements OnInit {
  @Input() numberOfSteps!: number;
  @Input() currentStep: number = 0;

  get steps() {
    return new Array(this.numberOfSteps);
  }

  constructor() { }

  ngOnInit(): void {
  }

}
